// Contador de tentativas consecutivas bem-sucedidas
let consecutiveSuccess = 0;
let monitorInterval = null;
let disconnectedTime = 0;

// Para o monitoramento e limpa recursos
const stopMonitoring = () => {
  if (monitorInterval) {
    clearInterval(monitorInterval);
    monitorInterval = null;
    consecutiveSuccess = 0;
    disconnectedTime = 0;
  }
};

// Limpa recursos quando a página for descarregada
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', stopMonitoring);
  window.addEventListener('unload', stopMonitoring);
}

// Inicia monitoramento automático na primeira chamada
const startMonitoring = () => {
  if (monitorInterval) {
    return;
  }

  monitorInterval = setInterval(() => {
    try {
      qz.websocket.getConnectionInfo();
      if (qz.websocket.isActive()) {
        consecutiveSuccess++;
        disconnectedTime = 0;
      } else {
        consecutiveSuccess = 0;
        disconnectedTime++;
        // Para monitoramento após 30s desconectado para economizar recursos
        if (disconnectedTime >= 30) {
          stopMonitoring();
        }
      }
    } catch (error) {
      consecutiveSuccess = 0;
      disconnectedTime++;
      // Para monitoramento após 30s com erro para economizar recursos
      if (disconnectedTime >= 30) {
        stopMonitoring();
      }
    }
  }, 1000);
};

const isConnected = () => {
  if (!monitorInterval) {
    startMonitoring();
  }
  return consecutiveSuccess >= 5;
};

// O certificado público pode ficar no frontend — não é informação secreta
const QZ_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIE5TCCAs2gAwIBAgIQNzkyMDI2MDQyNDIwMjY1MTANBgkqhkiG9w0BAQ0FADCB
mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry
aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ
cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz
dHJpZXMuY29tMB4XDTI2MDQyNDIwMjY1MVoXDTI3MDQyNDIxMjMwM1owgZ4xCzAJ
BgNVBAYMAkJSMQswCQYDVQQIDAJNRzESMBAGA1UEBwwJUmlvIFBvbWJhMRcwFQYD
VQQKDA5CaWdvdSBEZWxpdmVyeTEXMBUGA1UECwwOQmlnb3UgRGVsaXZlcnkxFzAV
BgNVBAMMDkJpZ291IERlbGl2ZXJ5MSMwIQYJKoZIhvcNAQkBDBR1bHlzc2VzQGxh
YmNpbmNvLmNvbTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBALLugpJO
VyL84cMg/sxYx8gowBq5eeKNn7xTrB0pPpHEHN5AVo7UCV2EhAMxbfiKut5bb89r
JK4jl21QeT+9t/EhOkC1wOGIFY78jjozgxoGtZSCqZ1Jor5m1zKdkVnZtFvyUFFA
i/PdAlN8zG472AvKooag/ro7CezwtVAtq5+gAzQwug4keDZb8dfi84lZXphw6XOu
ognPxw6WGjqZURnaHn06sUqNuUH2MH9UDMUe56VoCrAabZqFOSpa0QEh4rnb5ZSQ
m/7u+e11yfYy8CXfltSRT3iCX6YjMjPK4oHRX2vv5PvaBYNZdCe8XHyHnpa0hO67
dEo6ZBYVC8FIEbkCAwEAAaMjMCEwHwYDVR0jBBgwFoAUkKZQt4TUuepf8gWEE3hF
6Kl1VFwwDQYJKoZIhvcNAQENBQADggIBACaCMOOHIzwJU8X/Y2mEDl7BxJQbiXbC
UoQLp/xKnUkcZA382JFqPYBVSGwrFZoNyHh9QRCm+WXEd02MktdXukZaz/xyPvhL
aiAuUN0Y460B/o6S30dvhHo7X8hDlQ+sRKbyjFqSL9Sy3BYajn8E5FFkp/Olcros
Bk1w1VEckY4eCfIK4wMz0ATCu6Z5JwwMGym1IsqALeCkwi/R7VzUf25MCFn/5Owd
gihR4iZUugoTP0REhZ8NHkhnsZPeJXX3aM/Q3iAhTtmMYiqiIlTrIVeJyJ3cT5HD
I0QU4Yzudq61sSNvQ43NkBwnYCSv2SAzpgBVDsOmptZJocx4c3jrfeunmIe5fAAM
WHlIr9+prWkMxL0Uag9OOPsI3yPNjYGwBEkVI4E8wKObfqpFplwMyfOWlhwhDvtg
ed+H0J3t5V15EATMED5fBRYgU0ss0XRByVLMNdN9PlDa84TSOTn+lg6qHX/tticx
H//3ODy9fOJbd6sjbhXFjCT4FAdSb+v8vblYXUdERuVz+9fNtGbTVRMFKDcv8tgk
PC22WbEtdJ157moUBhH2VyJ5LnlLxAIJPoRU0DGreEkLyz72qG4n80ZwJrchHHaW
obuSNU/CMfMnwOnFGcB3HeeeDxCONq2ngjiTmuE8neRpDs5i9JjwPSTw0HaY3ghZ
GkLeBnJyhq36
-----END CERTIFICATE-----
--START INTERMEDIATE CERT--
-----BEGIN CERTIFICATE-----
MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT
MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ
bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG
A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx
emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow
gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0
cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM
EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1
c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU
iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H
YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM
GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH
EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh
0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX
xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1
9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE
ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD
2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX
6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY
5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ
plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S
BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ
eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k
gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT
x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu
pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw
2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp
rbO7BnjW
-----END CERTIFICATE-----`;

const setCertificate = () => {
  qz.security.setCertificatePromise(function (resolve) {
    resolve(QZ_CERTIFICATE);
  });

  // A private key nunca trafega no frontend — a assinatura é feita pelo backend.
  // setSignaturePromise do QZ Tray (RSVP) exige que o callback retorne uma função
  // (resolve, reject) — não uma Promise nativa.
  qz.security.setSignaturePromise(function (toSign) {
    return function (resolve, reject) {
      window.getApp.$axios
        .post('/qz/sign', { toSign })
        .then(res => resolve(res.data.signature))
        .catch(err => {
          console.error('Erro ao obter assinatura QZ:', err);
          reject(err);
        });
    };
  });
};

// Solicita permissão de Local Network Access (LNA) ao Chrome.
// LNA é a evolução do PNA (Private Network Access) — Chrome 130+ expõe a permissão
// via Permissions API, permitindo solicitar o prompt nativo sem depender de headers do servidor.
// Fallback: fetch CORS para versões mais antigas (Chrome 94–129) que usam PNA via preflight.
const requestLocalNetworkAccess = async () => {
  if (window.location.protocol !== 'https:') {
    return;
  }

  // Chrome 130+: Permissions API com 'local-network-access'
  if (navigator.permissions && navigator.permissions.request) {
    try {
      const result = await navigator.permissions.request({ name: 'local-network-access' });
      if (result.state === 'granted') {
        return;
      }
    } catch (_) {
      // Permissão não suportada nesta versão — tenta fallback PNA
    }
  }

  // Fallback PNA (Chrome 94–129): fetch CORS envia preflight com
  // Access-Control-Request-Private-Network: true, o que pode exibir o prompt
  try {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), 2000);
    await fetch('https://localhost:8181/', { signal: controller.signal });
  } catch (_) {
    // Ignorado — falha esperada (CORS/cert); o objetivo é apenas disparar o prompt
  }
};

const connect = async () => {
  consecutiveSuccess = 0; // Reset contador
  disconnectedTime = 0;
  try {
    if (qz.websocket.isActive()) {
      return;
    }
    await requestLocalNetworkAccess();
    setCertificate();
    await qz.websocket.connect();
    // Inicia monitoramento após conexão bem-sucedida
    if (!monitorInterval) {
      startMonitoring();
    }
  } catch (error) {
    // Para monitoramento em caso de erro de conexão
    stopMonitoring();
    const isNetworkError = window.location.protocol === 'https:' && (String(error).includes('WebSocket') || String(error).includes('connect'));
    if (isNetworkError) {
      throw new Error(
        `Não foi possível conectar ao QZ Tray.\n\nNo Chrome, clique no ícone de cadeado na barra de endereço → "Apps no dispositivo" → Permitir. Em seguida, recarregue a página.`
      );
    }
    throw new Error(error);
  }
};

const getPrinters = async () => {
  try {
    if (!qz.websocket.isActive()) {
      throw new Error('QZ Tray não está conectado.');
    }
    const printers = await qz.printers.find();
    return printers;
  } catch (error) {
    throw new Error(error);
  }
};

const getPrinter = async printer => {
  try {
    if (!qz.websocket.isActive()) {
      throw new Error('QZ Tray não está conectado.');
    }
    return await qz.printers.find(printer.name || '');
  } catch (error) {
    throw new Error(error);
  }
};

//=========================== IMPRESSÃO HTML ===========================

const print = async ({ pedido = {}, printers = [], layout = {} }) => {
  try {
    if (!Array.isArray(printers) || printers.length == 0) {
      throw new Error("Nenhuma impressora foi fornecida.");
    }
    if (!qz.websocket.isActive()) {
      throw new Error('QZ Tray não está conectado.');
    }

    for (let printer of printers) {
      var config = qz.configs.create(printer.nome);
      var data = formatarPedido({ pedido, tamanho: printer.tamanho || 1, layout: printer.layout || layout.id || 1 });
      if (['local', 'development', 'stage'].includes(process.env.VUE_APP_NODE_ENV)) {
        console.log(printer);
        console.log(data);
      }
      await qz.print(config, data);
    }
    return true;
  } catch (error) {
    throw new Error(error);
  }
};

const formatarPedido = ({ pedido, tamanho = 1, layout = 1 }) => {
  const data = [];
  const filters = window.getApp.$root.$options.filters;
  const dayjs = window.getApp.$dayjs;
  const smallText = tamanho == 1 ? '\x1B\x4D\x31' : '';

  function toUpper(txt) {
    return txt ? filters.removeAccents(txt).toUpperCase() : "";
  }

  let previsao = '\x0A';

  if (pedido.status != 3 && pedido.status != 0 && pedido.tempo_entrega) {
    const lbPrevisao = pedido.endereco.id == -1 ? 'PREVISAO DE RETIRADA: ' : 'PREVISAO DE ENTREGA: ';
    const tempo = dayjs(pedido.data).add(pedido.tempo_entrega, 'minutes').format('DD/MM/YYYY - HH:mm');
    previsao = `${lbPrevisao}${tempo}\x0A`;
  }

  const isCardapioDigital = pedido.cardapio_digital == 1;

  data.push(
    `\x1B\x40` +          // init
    // '\x1B\x61\x30'+ // left align
    `\x1B\x21\x30` // em mode on
  );

  data.push(
    `\x1B\x45\x0D` + // bold on
    `\x1B\x61\x31` + // center align
    `${smallText}` + // small text
    `${isCardapioDigital ? 'CARDAPIO DIGITAL' : 'BIGOU DELIVERY'}\x0A\x0A`
  );

  data.push(
    `\x1B\x61\x30` + // left align
    `\x1B\x21\x0A\x1B\x45\x0A` // em mode off
  );

  if ([1, 2].includes(layout)) {
    data.push(
      `${smallText}` + // small text
      `\x1B\x45\x0A` + `FORNECEDOR: ${toUpper(pedido.estabelecimento.nome)}\x0A`
    );
  }

  data.push(
    `${smallText}` + // small text
    `PEDIDO: \x1B\x45\x0D${pedido.id}\x1B\x45\x0A\x0A`
  );

  if ([1, 2].includes(layout)) {
    data.push(
      `DATA: ${dayjs(pedido.data).format('DD/MM/YYYY - HH:mm')}\x0A`,
      previsao
    );
  }

  if ([1, 2].includes(layout)) {
    data.push(
      `\x1B\x45\x0D` + // bold on
      `\x1B\x61\x31` + // center align
      `${smallText}` + // small text
      `\x0A============ DADOS DA ENTREGA ===========\x0A\x0A` +
      `\x1B\x45\x0A` + // bold off
      `\x1B\x61\x30` + // left align
      `${smallText}` // small text
    );
  }

  data.push(
    `CLIENTE: ${toUpper(pedido.usuario.nome)}\x0A`
  );

  if ([1, 2].includes(layout)) {
    data.push(
      `TELEFONE: ${filters.telefone(pedido)}\x0A`
    );

    data.push(
      `ENDERECO: ${toUpper(filters.endereco(pedido.endereco))}\x0A`
    );

    data.push(
      `REFERENCIA: ${toUpper(pedido.endereco.referencia)}\x0A`
    );
  }

  data.push(
    `\x1B\x45\x0D` + // bold on
    `\x1B\x61\x31` + // center align
    `${smallText}` + // small text
    `\x0A============= ITENS DO PEDIDO ===========\x0A\x0A` +
    `\x1B\x61\x30` + // left align
    `\x1B\x45\x0A` // bold off
  );

  if (layout == 1) {
    for (var i in pedido.itens) {
      const item = pedido.itens[i];
      data.push(`${item.quantidade} UNID. ${toUpper(item.item.categoria)}: ${toUpper(item.item.nome)} - ${filters.currency((item.preco_base * item.quantidade), 'RS', 2)}\x0A`);
      if (item.variacoes.length) {
        for (var j in item.variacoes) {
          const variacao = item.variacoes[j];
          const preco = variacao.mod_preco == 1 && variacao.preco > 0 ? ` - ${filters.currency(variacao.preco * item.quantidade, 'RS', 2)}` : '';
          data.push(` - ${toUpper(variacao.variacao.nome)}: ${toUpper(variacao.item.nome)}${preco}\x0A`);
        }
      }
      if (item.observacao) {
        data.push(`OBS.: ${toUpper(item.observacao)}\x0A`);
      }
      if (i < (pedido.itens.length - 1)) {
        data.push(`-----------------------------------------\x0A`);
      }
    }
  } else {
    for (var i in pedido.itens) {
      const item = pedido.itens[i];
      if (layout == 2) {
        data.push(`${item.quantidade}x ${toUpper(item.item.nome)} - ${filters.currency(item.preco_base, 'RS', 2)}\x0A`);
      } else if (layout == 3) {
        data.push(`${item.quantidade}x ${toUpper(item.item.nome)}\x0A`);
      }
      if (item.item.cod_bar) {
        data.push(`CODIGO: ${item.item.cod_bar}\x0A`);
      }
      if (item.variacoes.length) {
        const grupos = {};
        for (var j in item.variacoes) {
          const v = item.variacoes[j];
          const key = v.item_catalogo_id;
          if (!grupos[key]) {
            grupos[key] = { quantidade: 0, nome: v.item.nome, variacao: v.variacao.nome, preco: 0, indice: v.item.indice_categoria || 0, mod_preco: v.mod_preco };
          }
          grupos[key].quantidade++;
          grupos[key].preco += v.preco;
        }
        const variacoesOrdenadas = Object.values(grupos).sort((a, b) => {
          if (a.indice !== b.indice) return a.indice - b.indice;
          if (a.variacao !== b.variacao) return a.variacao.localeCompare(b.variacao);
          return a.nome.localeCompare(b.nome);
        });
        for (const v of variacoesOrdenadas) {
          const preco = v.mod_preco == 1 && v.preco > 0 ? ` + ${filters.currency(v.preco, 'RS', 2)}` : '';
          if (layout == 2) {
            data.push(` - ${v.quantidade}x ${toUpper(v.nome)}${preco}\x0A`);
          } else if (layout == 3) {
            data.push(` - ${v.quantidade}x ${toUpper(v.nome)}\x0A`);
          }
        }
      }
      if (item.observacao) {
        data.push(`OBS.: ${toUpper(item.observacao)}\x0A`);
      }
      if (i < (pedido.itens.length - 1)) {
        data.push(`-----------------------------------------\x0A`);
      }
    }
  }

  if (pedido.observacao) {
    data.push(
      `\x1B\x45\x0D` + // bold on
      `\x1B\x61\x31` + // center align
      `${smallText}` + // small text
      `\x0A========== OBSERVACAO DO PEDIDO =========\x0A` +
      `\x1B\x61\x30` + // left align
      `\x1B\x45\x0A` + // bold off
      `\x0A` +
      `${toUpper(pedido.observacao)}\x0A`
    );
  }

  if ([1, 2].includes(layout)) {
    data.push(
      `\x1B\x45\x0D` +   // bold on
      `\x1B\x61\x31` +   // center align
      `${smallText}` + // small text
      `\x0A=============== PAGAMENTO ===============\x0A` +
      `\x1B\x45\x0A` + // bold off
      `\x0A` +
      `\x1B\x61\x30`  // left align
    );

    data.push(
      `SUBTOTAL:.............. ${filters.currency(pedido.subtotal, 'RS', 2)}\x0A`
    );

    if (pedido.endereco_id > 0) {
      data.push(
        `TAXA DE ENTREGA:....... ${filters.currency(pedido.taxa_entrega, 'RS', 2)}\x0A`
      );
    }
    if (pedido.taxa_servico) {
      data.push(
        `TAXA DE SERVICO:....... ${filters.currency(pedido.taxa_servico, 'RS', 2)}\x0A`
      );
    }
    if (pedido.cupom_desconto_id) {
      data.push(
        `CUPOM DESCONTO:........ -${filters.currency(pedido.desconto, 'RS', 2)}\x0A`
      );
    }

    data.push(
      `\x1B\x45\x0DTOTAL:................. ${filters.currency(pedido.total, 'RS', 2)}\x1B\x45\x0A\x0A` +
      `FORMA DE PAGAMENTO:.... ${toUpper(pedido.formaPagamento.nome)}\x0A`
    );

    if (pedido.troco) {
      data.push(
        `PAGAMENTO:............. ${filters.currency(pedido.troco, 'RS', 2)}\x0A`
      );
      data.push(
        `TROCO:................. ${filters.currency(pedido.troco - pedido.total, 'RS', 2)}\x0A`
      );
    }
  }

  data.push(
    `\x1B\x61\x31` +   // center align
    `${smallText}` + // small text
    `\x0A-----------------------------------------\x0A` +
    `CUPOM NAO FISCAL\x0A` +
    `${!isCardapioDigital ? 'www.bigou.com.br' : ''}\x0A` + // text and line break
    `\x0A\x0A\x0A\x0A\x0A` +
    `\x1B\x69` +            // cut paper
    `\x10\x14\x01\x00\x05`  // Generate Pulse to kick-out cash drawer**
  );

  return data;
};

const isActive = () => {
  try {
    return qz.websocket.isActive();
  } catch (e) {
    return false;
  }
};

export default {
  isConnected,
  isActive,
  connect,
  getPrinters,
  getPrinter,
  print,
  formatarPedido,
};
